import { render, staticRenderFns } from "./IncomeTaxCalculator.vue?vue&type=template&id=7d1ab53e&scoped=true&"
import script from "./IncomeTaxCalculator.vue?vue&type=script&lang=ts&"
export * from "./IncomeTaxCalculator.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeTaxCalculator.vue?vue&type=style&index=0&id=7d1ab53e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1ab53e",
  null
  
)

export default component.exports